import type { PropsWithChildren } from 'preact/compat';
import Icon from '../icon/Icon';
import './AssistantHomeItemCard.less';
import type { AssistantHomeItem } from '../../models/AssistantHomeItem';

export type AssistantHomeItemCardProps = PropsWithChildren<{
    homeItem: AssistantHomeItem;
    animationDelay: number;
    onClick: () => void;
    className?: string;
}>;

const AssistantHomeItemCard = ({
    homeItem,
    animationDelay,
    onClick,
    className = '',
    children
}: AssistantHomeItemCardProps) => (
    <div
        className={`bri-AssistantHomeItemCard ${className}`}
        onClick={onClick}
        role={'button'}
        tabIndex={0}
        style={{ animationDelay: `${animationDelay}ms` }}
    >
        {children}
        {!children && (
            <>
                <div className={`bri-DisplayFont`}>{homeItem.text}</div>
                <div
                    className={`bri-AssistantHomeItemCard-footer bri-BodySmallFont`}
                >
                    <span className="bri-AssistantHomeItemCard-footer-text">
                        {homeItem.footerText}
                    </span>
                    <Icon iconId="arrow-right" size="small" />
                </div>
            </>
        )}
    </div>
);

export default AssistantHomeItemCard;
